import { TrashIcon } from '@diligentcorp/atlas-react-icons';
import { IconButton, Stack, styled } from '@mui/material';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { SLAFormValues } from '../hooks';

type Props = {
  field: {
    id: string;
    handleDelete: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    reminderDays: React.JSX.Element;
  };
  form: UseFormReturn<SLAFormValues, any, SLAFormValues>;
};

const iconButtonSx = {
  p: 1,
  ml: 2,
};

const StyledIconButton = styled(IconButton)<{ hasError: boolean }>(
  ({ hasError }) => ({
    ...iconButtonSx,
    mb: hasError ? '27px' : 0,
  }),
);

export function ReminderDaysField(props: Props) {
  const { field, form } = props;

  return (
    <Stack
      key={field.id}
      flexDirection='row'
      width='100%'
      alignItems='flex-end'
    >
      {field.reminderDays}
      <StyledIconButton
        onClick={(e) => {
          field.handleDelete(e);
        }}
        hasError={Boolean(form.formState.errors?.reminderDays)}
        data-testid='delete'
      >
        <TrashIcon />
      </StyledIconButton>
    </Stack>
  );
}
